import React from "react";
import { QrReader } from "react-qr-reader";

function BarcodeScanner({
    scanDetailsHandler,
}) {
    const onScanBarcode = (data) => {
        if (data) {
            scanDetailsHandler(data)
        }
    }

    return (
         <div
      style={{
        width: "500px",
        height: "400px",
        marginTop: "-40px",
      }}
    >
      <QrReader
        constraints={{ facingMode: "environment" }}
        onResult={(result, error) => {
          if (!!result) {
            onScanBarcode(result?.text);
          }
        }}
        containerStyle={{
          width: "100%",
          height: "100%",
        }}
        videoContainerStyle={{
          paddingTop: "80%",
        }}
        videoStyle={{
          width: "100%",
          height: "100%",
        }}
      />
    </div>
    );
}

export default BarcodeScanner;